jQuery(function ($) {
  new Rellax(".rellax", {
  });
});
